import { render } from "./MenuItemFolderDropdown.vue?vue&type=template&id=0047c3fe&scoped=true"
import script from "./MenuItemFolderDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuItemFolderDropdown.vue?vue&type=script&setup=true&lang=js"

import "./MenuItemFolderDropdown.vue?vue&type=style&index=0&id=0047c3fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0047c3fe"],['__file',"src/components/MenuItemFolderDropdown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0047c3fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0047c3fe', __exports__)) {
    api.reload('0047c3fe', __exports__)
  }
  
  module.hot.accept("./MenuItemFolderDropdown.vue?vue&type=template&id=0047c3fe&scoped=true", () => {
    api.rerender('0047c3fe', render)
  })

}


export default __exports__